import { defineComponent as _defineComponent } from 'vue'
import VLoader from "../components/loader.vue"
import { ref, onMounted, watch, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router';
import { Userspaces } from '@busy-human/opt-library'
import SetupInstructions from '../components/setup/instructions-setup.vue'
import SetupCalendar from '../components/setup/calendar-setup.vue'
import SetupAvailability from '@/components/setup/availability-setup.vue'
import SetupReady from '@/components/setup/ready-setup.vue'
import SetupRate from '@/components/setup/rate-setup.vue'
import SetupQR from '@/components/setup/qr-setup.vue'
import SetupProfile from '@/components/setup/profile-setup.vue'
import SetupPayment from '@/components/setup/payment-setup.vue'
import { useUserspace } from "@/store/userspace";

enum SetupStage {
    // INSTRUCTIONS = 8,
    CALENDAR = 1,
    AVAILABILITY = 2,
    RATE = 3,
    READY = 4,
    PAYMENT = 5,
    QRCODE = 6,
    PROFILE = 7,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'setup',
  setup(__props, { expose }) {
  expose();

const loading = ref(true)
const errorMsg = ref("")

const router = useRouter();

const routeTo = (route: string) => {
    router.push(`/${route}`)
}

let mode = ref(SetupStage.CALENDAR)

// let goBack = () => {
//     mode.value = (mode.value <= 1 ) ? 8 : mode.value - 1;
// }
const changeMode = (newMode: SetupStage) => {
    errorMsg.value = ""
    mode.value = newMode
}
//maybe???

const userspace = useUserspace();
onBeforeMount(async () => {
    let user = userspace.user;
    if(!user.userDidSignupFromMeetingInvite) {
        if (!user.setupCompleted) {
            await Userspaces.Collection.updateDoc(user.$id!, {
                setupCompleted: []
            })
        }
    }
})

onMounted(() => {
    let user = userspace.user;

    if (user.setupCompleted) {
        if (!user.setupCompleted.includes('CALENDAR')) {
            mode.value = SetupStage.CALENDAR
        }
        else if (!user.setupCompleted.includes('AVAILABILITY')) {
            mode.value = SetupStage.AVAILABILITY
        }else{
            mode.value = SetupStage.READY
        }
    }

    loading.value = false;
})

const completeSetup = (setupPage: string) => {
    let user = userspace.user;
    let userSetupCompleted = user.setupCompleted
    if (!userSetupCompleted.includes(setupPage)) {
        userSetupCompleted.push(setupPage)

        Userspaces.Collection.updateDoc(user.$id!, {
            setupCompleted: userSetupCompleted
        })
    }
}

const noScroll = ref(false)

const __returned__ = { loading, errorMsg, router, routeTo, SetupStage, mode, changeMode, userspace, completeSetup, noScroll, VLoader, ref, onMounted, watch, onBeforeMount, useRouter, Userspaces, SetupInstructions, SetupCalendar, SetupAvailability, SetupReady, SetupRate, SetupQR, SetupProfile, SetupPayment, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})